import { strLang } from "../functions/strLang";
import { colorsList } from "./colorsList";

export const groupsColors = [
  { value: "", color: colorsList.red, label: strLang("default") },
  { value: colorsList.yellow, label: strLang("colorsList").yellow },
  { value: colorsList.blue, label: strLang("colorsList").blue },
  { value: colorsList.purple, label: strLang("colorsList").purple },
];
